// extracted by mini-css-extract-plugin
module.exports = {"copied":"CopyableText_copied__3cP5K","flash":"CopyableText_flash__1NjrJ"};